// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"b86cf798","121":"3f314c8f","153":"288e8f33","213":"864e84d6","229":"e0f4b99e","280":"041567d0","334":"0eaeb254","455":"2ec308c5","729":"052fb079","730":"fa372e4b","813":"72d5392c"}[chunkId] + ".chunk.js";
};